import React, { useState } from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { DateHandler } from '@angle/utils'
import { ICensusForm } from './types'
import { AddOrEditMemberModal } from './AddOrEditMemberModal'
import styled from 'styled-components'

import trashCan from '../../trashCan.svg'

const TableCell = styled.td`
  padding-top: 20px !important;
  padding-bottom: 20px !important;
`

const mapTier = (val: string) => {
  switch (val) {
    case 'single':
      return 'Employee'
    case 'employee_spouse':
      return 'Employee + Spouse'
    case 'employee_children':
      return 'Employee + Child(ren)'
    case 'family':
      return 'Employee + Family'
    default:
      return null
  }
}

const capitalize = (val: string) => val[0].toUpperCase() + val.substring(1)

export const CensusTableRow: React.FC<{
  row: ICensusForm
  rowIdx: number
}> = ({ row, rowIdx }) => {
  const defaultValues = row

  const { control } = useFormContext()

  const { remove } = useFieldArray({ control, name: 'censusInfo' })

  const [showEditModal, setShowEditModal] = useState(false)

  const onClickEditRow = () => {
    setShowEditModal(true)
  }

  const onClickDeleteRow = () => {
    remove(rowIdx)
    setShowEditModal(false)
  }

  return (
    <tr key={rowIdx}>
      <AddOrEditMemberModal
        key={JSON.stringify(row)}
        show={showEditModal}
        setShow={setShowEditModal}
        rowIdx={rowIdx}
        defaultValues={defaultValues}
      />
      <TableCell style={{ fontWeight: 500 }}>
        {row.firstName} {row.lastName}
      </TableCell>

      <TableCell className="text-secondary">
        {DateHandler.formatForClient(row.dateOfBirth)}
      </TableCell>
      <TableCell className="text-secondary">{row.zipCode}</TableCell>
      <TableCell className="text-secondary">
        {capitalize(row.relationship)}
      </TableCell>
      <TableCell className="text-secondary">{capitalize(row.gender)}</TableCell>
      <TableCell className="text-secondary">
        {mapTier(row.familyTier)}
      </TableCell>
      <TableCell className="text-secondary">{row.prevPlanName}</TableCell>
      <TableCell>
        <div className="d-flex">
          <div role="button" className="ml-5 mr-3" onClick={onClickEditRow}>
            <i
              className="icon icon-pencil text-primary fs-12"
              style={{ height: '100%', width: '0.8rem' }}
            />
          </div>
          <div role="button" onClick={onClickDeleteRow}>
            <img src={trashCan} alt="delete" />
          </div>
        </div>
      </TableCell>
    </tr>
  )
}
